<template>
   <div v-if="dt" class="d-flex align-items-end flex-column bd-highlight my-1">
      <div class="p-2 result-datatable-count-rows">Resultados obtenidos: {{ totalRecords }}</div>
   </div>
   <div>
      <DataTable
         :value="items"
         :lazy="true"
         :paginator="true"
         :rows="10"
         ref="dt"
         dataKey="id"
         :totalRecords="totalRecords"
         :loading="loading"
         @page="onPage($event)"
         @sort="onSort($event)"
         responsiveLayout="scroll"
         stripedRows
         sortField="NOMBRESO"
         :sortOrder="1"
         :rowsPerPageOptions="[10, 20, 50, 100, 300, 500]"
         paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
         currentPageReportTemplate="Resultados {first}-{last} de {totalRecords}"
      >
         <DataColumn field="NOMBRESO" header="Actor político" :sortable="true"></DataColumn>
         <DataColumn field="NOMBREESTADO" header="Entidad" :sortable="true"></DataColumn>
         <DataColumn field="COMITEPARTIDO" header="Comité del partido" :sortable="true"></DataColumn>
         <DataColumn
            field="FECHA_INICIO_OPERACION"
            header="Fecha inicio de la operación"
            :sortable="true"
            bodyStyle="text-align: center"
         ></DataColumn>
         <DataColumn header="Acciones" headerClass="result-datatable-column-actions-header" bodyClass="result-datatable-column-actions-body">
            <template #body="{ data }">
               <PrimeButton
                  icon="pi pi-search"
                  class="p-button-text p-button-plain w-100 result-datatable-column-actions-body-button"
                  label="Ver detalle"
                  @click="showResult(data)"
               />
            </template>
         </DataColumn>
      </DataTable>
      <p>-</p>
   </div>
</template>

<script setup>
import { onMounted, defineProps, defineExpose, ref } from "vue";
import FiltersOrdinarioDataService from "@/service/FiltersOrdinarioDataService";
import AppConfig from "@/conf/global";

const props = defineProps({
   idOrganizacion: Number,
   idSujetoObligado: Number,
   ambito: Number,
   idEstado: Number,
   secondary: Boolean,
   showResult: Function,
});

const dt = ref();
const loading = ref(false);
const totalRecords = ref(0);
const items = ref();

const lazyParams = ref({});

//const filters = ref({});

const loadLazyData = () => {
   loading.value = true;
   //console.log(props);

   const params = FiltersOrdinarioDataService.setFilters(
      props.idSujetoObligado,
      props.idEstado,
      props.idOrganizacion,
      props.ambito,
      lazyParams.value.first,
      lazyParams.value.rows,
      lazyParams.value.sortField,
      lazyParams.value.sortOrder,
      null
   );
   FiltersOrdinarioDataService.getContabilidades(props.secondary, params)
      .then((res) => {
         //console.log(res.data);
         items.value = res.data.body;
         //loading.value = false;

         FiltersOrdinarioDataService.getContabilidadesConteo(props.secondary, params)
            .then((res1) => {
               totalRecords.value = res1.data.body[0].TOTALCONTABILIDAD;
               //console.log(res1.data[0].TOTALCONTABILIDAD);
               loading.value = false;
            })
            .catch((err) => {
               console.log("Error en conteo");
               console.log(err);
               loading.value = false;
            });
      })
      .catch((err) => {
         console.log("Error en lista");
         console.log(err);
         loading.value = false;
      });
};

const onPage = (event) => {
   lazyParams.value = event;
   //console.log(event);
   //console.log(lazyParams);
   loadLazyData();
};
const onSort = (event) => {
   lazyParams.value = event;
   loadLazyData();
};

defineExpose({
   loadLazyData,
});

onMounted(() => {
   //console.log(props);
   loading.value = false;

   lazyParams.value = {
      first: AppConfig.indexFirstElementDefault,
      rows: dt.value.rows,
      sortField: AppConfig.orderFieldOrdinaryDefault,
      sortOrder: AppConfig.orderTypeDefault,
      //filters: filters.value,
   };
   loadLazyData();
});
</script>
